const generateIdentifier = name => `${Math.random().toString(36).substring(7)}-${name}`;

const validationFactory = (name, { validationModel, validationMessage, blurNativeCallback }) => {
  const identifier = generateIdentifier(name);
  return function computed() {
    return {
      input: {
        id: identifier,
        state: this.$bsStateValidator(validationModel(this).$error),
      },
      inputEvent: {
        blurNative: () => {
          validationModel(this).$touch();
          if (blurNativeCallback) {
            blurNativeCallback(this);
          }
        },
      },
      validationModel: validationModel(this),
      validationMessage: validationMessage(this),
    };
  };
};

/**
 * Constrói um contexto de validações de um ou mais campos,
 * tendo como base o uso do vuelidate. Para facilitar o uso. Para ter uso facilitado,
 * invoque a função createValidationContext usando spread no objeto computed da vue do vue,
 * ele irá adiciona uma computed property na vm do vue para cada campo com o
 * sufixo ValidationContext. Ex: nameValidationContext.
 *
 * Exemplo de uso:
 *
 * computed: {
 *    ...createValidationContext({
 *    name: {
 *       validationModel: vm => vm.$v.profile.name,
 *       validationMessage: vm => vm.nameValidationTooltip,
 *       blurNativeCallback: vm => vm.checkNameAvailable(),
 *     },
 *     description: {
 *       validationModel: vm => vm.$v.profile.description,
 *       validationMessage: vm => vm.descriptionValidationTooltip,
 *     },
 *   })
 * }
 *
 * @param {Object} fields Um objeto onde cada propriedade é um campo a ser validado, e o seu valor é
 * um objeto de configuração contendo: validationModel, validationMessage
 * e opcionalmente blurNativeCallback, as propriedades de configuração devem ser funções que recebem
 * como parametro a vm do vue.
 * validationModel: Retorna Objeto de contexto da validação do vuelidate ex. this.$v.name
 * validationMessage: Retorna a mensagem de validação exibida
 * blurNativeCallback: Função invocada após a saída do foco do campo. (blur.native)
 */
export const createValidationContext = (fields) => {
  const getters = { };
  Object.keys(fields).forEach((fieldName) => {
    getters[`${fieldName}ValidationContext`] = validationFactory(fieldName, fields[fieldName]);
  });
  return getters;
};

export default {
  createValidationContext,
};
